import { createTheme } from "@mui/material/styles";

/** The Assembly's brand palette. The gold carries every primary button. */
/** Sidebar chrome. */
export const sidebar = {
  background: "#00293b",
  text: "#ffffff",
  mutedText: "#a6b0cf",
  accent: "#c1a155",
  width: 290,
} as const;

export const theme = createTheme({
  palette: {
    primary: { main: "#c1a155", contrastText: "#ffffff" },
    secondary: { main: sidebar.background },
    background: { default: "#f5f5f5" },
  },
  typography: {
    fontFamily: "Quicksand, Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        // Buttons are not shouted, and a text button on white uses the
        // neutral text colour -- the brand gold does not meet contrast there
        // and does not read as a button.
        root: { textTransform: "none" },
        text: { color: "rgba(0, 0, 0, 0.78)" },
      },
    },
    MuiTextField: { defaultProps: { size: "small", variant: "outlined" } },
  },
});
